/**
 * @generated SignedSource<<e715feef73ca7f83e919cd8ee00d6525>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EntityKind = "ORGANIZATION" | "USER";
import { DateTime } from "@/common/relayCustomScalar";
import { Url } from "@/common/relayCustomScalar";
export type EntityScaffoldQuery$variables = {
  username: string;
};
export type EntityScaffoldQuery$data = {
  readonly entityByUsername: {
    readonly bio: string | null | undefined;
    readonly createdAt: DateTime;
    readonly displayName: string;
    readonly github: string | null | undefined;
    readonly googleScholar: string | null | undefined;
    readonly id: string;
    readonly imageThumbnail: Url | null | undefined;
    readonly jobTitle?: string | null | undefined;
    readonly karma?: number;
    readonly kind: EntityKind;
    readonly linkedPapers?: {
      readonly totalCount: number;
    };
    readonly linkedin: string | null | undefined;
    readonly location: string | null | undefined;
    readonly orcid?: string | null | undefined;
    readonly organization?: string | null | undefined;
    readonly username: string;
    readonly viewerCanConfigureNotifications?: boolean;
    readonly viewerCanEdit?: boolean;
    readonly website: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"EntityHelmetFragment" | "EntityProfilePicFragment">;
  } | null | undefined;
  readonly viewer: {
    readonly id: string;
  };
};
export type EntityScaffoldQuery = {
  response: EntityScaffoldQuery$data;
  variables: EntityScaffoldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkedin",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "github",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleScholar",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "website",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bio",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "action",
    "value": "UPDATE_USER"
  }
],
v15 = {
  "alias": "viewerCanEdit",
  "args": (v14/*:: as any*/),
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_USER\")"
},
v16 = {
  "alias": "viewerCanConfigureNotifications",
  "args": (v14/*:: as any*/),
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_USER\")"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organization",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobTitle",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "karma",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orcid",
  "storageKey": null
},
v21 = {
  "alias": "linkedPapers",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 0
    }
  ],
  "concreteType": "PaperConnection",
  "kind": "LinkedField",
  "name": "papers",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": "papers(first:0)"
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "viewerCanEdit",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_ORGANIZATION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_ORGANIZATION\")"
    }
  ],
  "type": "Organization",
  "abstractKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EntityScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "entityByUsername",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          {
            "args": [
              {
                "kind": "Literal",
                "name": "thumbnail",
                "value": false
              }
            ],
            "kind": "FragmentSpread",
            "name": "EntityProfilePicFragment"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/)
            ],
            "type": "User",
            "abstractKey": null
          },
          (v22/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntityHelmetFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EntityScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v23/*:: as any*/),
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "entityByUsername",
        "plural": false,
        "selections": [
          (v23/*:: as any*/),
          (v1/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "last",
                    "value": 10
                  }
                ],
                "concreteType": "CommentConnection",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "content",
                        "storageKey": null
                      },
                      (v12/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "votes",
                        "storageKey": null
                      },
                      (v1/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "comments(last:10)"
              }
            ],
            "type": "User",
            "abstractKey": null
          },
          (v22/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f16e34ff2526f19e361ec2e4a1b056b6",
    "id": null,
    "metadata": {},
    "name": "EntityScaffoldQuery",
    "operationKind": "query",
    "text": "query EntityScaffoldQuery(\n  $username: String!\n) {\n  viewer @ifAllowed {\n    __typename\n    id\n  }\n  entityByUsername(username: $username) {\n    __typename\n    id\n    kind\n    displayName\n    location\n    username\n    linkedin\n    github\n    googleScholar\n    website\n    bio\n    createdAt\n    imageThumbnail\n    ...EntityProfilePicFragment_db32b\n    ... on User {\n      viewerCanEdit: viewerCan(action: UPDATE_USER)\n      viewerCanConfigureNotifications: viewerCan(action: UPDATE_USER)\n      organization\n      jobTitle\n      karma\n      orcid\n      linkedPapers: papers(first: 0) {\n        totalCount\n      }\n    }\n    ... on Organization {\n      viewerCanEdit: viewerCan(action: UPDATE_ORGANIZATION)\n    }\n    ...EntityHelmetFragment\n  }\n}\n\nfragment EntityHelmetFragment on Entity {\n  __isEntity: __typename\n  id\n  kind\n  displayName\n  location\n  username\n  linkedin\n  github\n  googleScholar\n  website\n  bio\n  createdAt\n  image\n  imageThumbnail\n  ... on User {\n    jobTitle\n    orcid\n    comments(last: 10) {\n      nodes {\n        content\n        createdAt\n        votes\n        id\n      }\n    }\n  }\n}\n\nfragment EntityProfilePicFragment_db32b on Entity {\n  __isEntity: __typename\n  displayName\n  image\n}\n"
  }
};
})();

(node as any).hash = "d415c43371f786e38fd8323f26ed58b7";

export default node;
